import React, { useEffect, useState } from "react";
import { Button, message, Modal, Tooltip, Checkbox } from "antd";
import AppointmentService from "../../../Services/AppointmentService";
import PatientService from "../../../Services/PatientService";
import { APP_ROUTES } from "../../../PageRouting/approutes";
import { useHistory } from "react-router-dom";
import Preview from "../../../Assets/Images/Svg/PreviewIcon.svg";
import moment from "moment";
import ConsultationService from "../../../Services/ConsultationService";
import PrescriptionDetails from "../ConsultationNotes/VitalTabs/ViewPrescription/PrescriptionDetails";
import { RWebShare } from "react-web-share";
import { IoPersonSharp } from "react-icons/io5";
import { MdCall } from "react-icons/md";
import CommonFunctions from "../../Shared/CommonFunctions";
import ShareOrders from "../NewDashboard/ShareOrders";
import ViewLabReports from "./ViewLabReports";
import MedOrderPreview from "./MedOrderPreview";
import LabOrderPreview from "./LabOrderPreview";
import close from "../../../Assets/Icons/close1.svg";
import SharePrescription from "../NewDashboard/SharePrescription";
import Edit from "../../../Assets/Icons/edit1.svg";
import View from "../../../Assets/Icons/visibility.svg";
import Share from "../../../Assets/Icons/share1.svg";
import { BiVideoPlus } from "react-icons/bi";
import NoAppointmentsCard from "./NoAppointmentsCard";
import EditWhite from "../../../Assets/Images/Svg/EditWhite.svg";
import ViewWhite from "../../../Assets/Images/Svg/ViewWhite.svg";
import ShareWhite from "../../../Assets/Images/Svg/ShareWhite.svg";
import MedWhite from "../../../Assets/Images/Svg/MedWhite.svg";
import LabWhite from "../../../Assets/Images/Svg/LabWhite.svg";
import { IoMdClose } from "react-icons/io";
import { FaCalendarAlt } from "react-icons/fa";
import RescheduleAppt from "../NewDashboard/RescheduleAppt";
import { useDispatch } from "react-redux";
import { getLoaderState } from "../../../Redux/actions/CommonActions";
import Summary from "../VideoConsultation/Summary";
import PayAgain from "../NewDashboard/PayAgain";
import { notifyPatient } from "../../../config/firebase";
import { setSelectedAppt } from "../../../Redux/actions/UserActions";

function UpcomeAppointment({
  upcomingList,
  setUpcomingList,
  upcomingAppointmentList,
}) {
  const [selectedPrescription, setSelectedPrescription] = useState(null);
  const [selectedPatient, setSelectedPatient] = useState(null);
  const [preview, setPreview] = useState(false);
  const [cancelReason, setCancelReason] = useState("");
  const [refundable, setRefundable] = useState(false);
  const [cancelAppointmentID, setCancelAppointmentID] = useState({});
  const [isModalOpen, setIsModalOpen] = useState(false);
  const history = useHistory();
  const [previewType, setPreviewType] = useState("M");
  const [medRecord, setMedRecord] = useState({});
  const [pharmaMed, setPharmaMed] = useState(false);
  const [showLabReport, setShowLabReport] = useState(false);
  const [labReportData, setLabReportData] = useState({});
  const dispatch = useDispatch();

  useEffect(() => {
    if (
      cancelAppointmentID &&
      cancelAppointmentID?.status === 1
      // &&
      // cancelAppointmentID?.paymentType === "Digital"
    ) {
      setRefundable(true);
    }
  }, [cancelAppointmentID]);

  const download = () => {
    setPreview(false);
  };
  const cancel = () => {
    setPreview(false);
  };

  const handlePharmaMedClose = () => {
    setPharmaMed(false);
  };

  const handlePrescriptionPreview = async (record) => {
    let patientPayload = {
      patientId: record?.patientId,
    };
    let consultationPayload = {
      consultationId: record?.consultationId,
      detailsYN: "Y",
    };
    try {
      const patientResponse = await PatientService.PatientListFilter(
        patientPayload
      );
      if (patientResponse) {
        setSelectedPatient(patientResponse.data[0]);
      }
      const consultationResponse = await ConsultationService.getPrescriptions(
        consultationPayload
      );
      if (consultationResponse.data) {
        setSelectedPrescription(consultationResponse.data[0]);
        setPreview(true);
      }
    } catch (e) {
      console.error(e);
    }
  };

  const handleClick = async (record, tab) => {
    dispatch(getLoaderState(true));

    if (tab === "1") {
      let payload = {
        appointmentId: record.appointmentId,
        modifiedBy: record.userId,
        modifiedDate: CommonFunctions.convertUTCDate(
          new Date(),
          "YYYY-MM-DD HH:mm:ss"
        ),
        patientId: record.patientId,
        startDateTime: CommonFunctions.convertUTCDate(
          new Date(),
          "YYYY-MM-DD HH:mm:ss"
        ),
        userId: record.userId,
        userName: record?.userName,
        personType: "Doctor",
      };

      ConsultationService.updateStartTime(payload).then((res) => { });
    }
    try {
      let payload = {
        patientId: record.patientId,
      };

      PatientService.PatientListFilter(payload).then((res) => {
        sessionStorage.setItem("patient", JSON.stringify(res.data[0]));
      });

      let apptPayload = {
        appointmentId: record.appointmentId,
      };

      let result = await AppointmentService.AppointmentFilter(apptPayload);
      await notifyPatient(record.patientId, record.appointmentId, record.userName, record.userId);
      dispatch(setSelectedAppt(record));
      sessionStorage.setItem("selectedAppt", JSON.stringify(record));
      history.push(APP_ROUTES.VIDEOCALL, { selectedPatient: result?.data[0] });
      window.scrollTo(0, 0);
    } catch (error) {
      message.error("An error occured try again");
    } finally {
      dispatch(getLoaderState(false));
    }
  };

  const handlePharmaMedOpen = (record, type) => {
    setPreviewType(type);
    setMedRecord(record);
    setPharmaMed(true);
  };

  const showModal = (record) => {
    setIsModalOpen(true);
    setCancelAppointmentID(record);
  };

  const cancelAppointment = () => {
    setIsModalOpen(false);
    setRefundable(false);
  };

  const handleRefundable = () => {
    setRefundable(!refundable);
  };

  const handleOk = () => {
    if (cancelReason === "") {
      message.error("Enter reason");
      return;
    }
    let payload = {
      appointmentId: cancelAppointmentID.appointmentId,
      cancelReason: cancelReason,
      cancelledById: cancelAppointmentID.userId,
      cancelledByType: "USER",
      refundYN: refundable ? "Y" : "N",
      paymentType: cancelAppointmentID.paymentType,
    };
    AppointmentService.AppointmentCancelNew(payload)
      .then((res) => {
        setIsModalOpen(false);
        upcomingAppointmentList();
        message.success("Appointment Cancelled");
        setCancelAppointmentID({});
        setRefundable(false);
        setCancelReason("");
      })
      .catch((error) => {
        message.error("Please try again");
      });
  };

  const getInitials = (name) => {
    if (!name) return "";
    name = name.replace(/^Mr\.?\s*/, "").trim();
    const initials = name.slice(0, 1).toUpperCase();
    return initials;
  };

  return (
    <div className="relative w-full">
      <div className="w-full overflow-x-auto">
        {upcomingList && upcomingList.length > 0 ? (
          <table className="w-full border border-gray-200 shadow-md rounded-md customTable ">
            <thead className="bg-[#F5FEFA] text-[#333333] text-left text-sm font-sans font-medium">
              <tr>
                <th className="p-3 whitespace-nowrap">Image</th>
                <th className="p-3 whitespace-nowrap">Patient</th>
                <th className="p-3 whitespace-nowrap">Appt ID</th>
                <th className="p-3 whitespace-nowrap">Chief Complaints</th>
                <th className="p-3 whitespace-nowrap">Date & Time</th>
                <th className="p-3 whitespace-nowrap">Call Type</th>
                <th className="p-3 whitespace-nowrap">Rx</th>
                <th className="p-3 whitespace-nowrap">Payment Status</th>
                <th className="p-3 whitespace-nowrap">Orders</th>
                <th className="p-3 whitespace-nowrap">Med Order ID</th>
                <th className="p-3 whitespace-nowrap">Lab Order ID</th>
                <th className="p-3 whitespace-nowrap">Appointment Status</th>
                <th className="p-3 whitespace-nowrap">Action</th>
              </tr>
            </thead>
            <tbody className="text-sm ">
              {upcomingList.map((record, index) => (
                <tr
                  key={index}
                  className="border-t border-gray-200 hover:bg-gray-50 font-sans font-medium text-sm text-[#333333]"
                >
                  <td className="p-3">
                    {record.photoName ? (
                      <img
                        src={
                          process.env.REACT_APP_IMAGE_URL + record?.photoName
                        }
                        alt={record.name}
                        className="w-10 h-10 rounded-full"
                      />
                    ) : (
                      <div className="h-10 w-10 rounded-full flex items-center justify-center text-white bg-brand-primaryColor">
                        <span>{getInitials(record.patientName)}</span>
                      </div>
                    )}
                  </td>
                  <td className="p-3 whitespace-nowrap">
                    <div>{record.patientName}</div>
                    <div className="text-brand-textDarkgray text-xs mb-0">
                      {record.patientId}
                    </div>
                  </td>
                  <td className="p-3 whitespace-nowrap">
                    {record.appointmentId}
                  </td>
                  <td className="p-3 whitespace-nowrap">
                    {record.appointmentReason}
                  </td>
                  <td className="p-3 whitespace-nowrap">
                    <span className="flex flex-col">
                      <span>
                        {moment
                          .utc(record.appointmentDate)
                          .local()
                          .format("DD/MM/YYYY")}
                      </span>
                      <span>{record.startTime}</span>
                    </span>
                  </td>
                  <td className="p-3">
                    {record.status === 2 || record.status === 9 ? (
                      <button
                        className="flex items-center  justify-center gap-2 w-28 px-1 py-2 border bg-gray-400 rounded text-white   cursor-not-allowed"
                        disabled
                      >
                        {record.serviceCode === "APPT_VIDEO" || record.serviceCode === "APPT_AUDIO" ? (
                          <>
                            {record.serviceCode === "APPT_VIDEO" ? (
                              <>
                                <BiVideoPlus className="w-5 h-5" />
                                Join call
                              </>
                            ) : (
                              <>
                                <MdCall className="w-5 h-5" />
                                c Call
                              </>
                            )}
                          </>
                        ) : (
                          <>
                            <IoPersonSharp className="w-5 h-5 " /> Consult
                          </>
                        )}
                      </button>
                    ) : !record.transactionId &&
                      record.paymentConsultation === "BC" ? (
                      <Tooltip
                        placement="top"
                        title={"payment is not completed"}
                      >
                        <button
                          className="bg-gray-400 text-white px-3 w-28 py-2 rounded flex items-center gap-1"
                          disabled
                        >
                          {record.serviceCode === "APPT_VIDEO" || record.serviceCode === "APPT_AUDIO" ? (
                            <>
                              {record.serviceCode === "APPT_VIDEO" ? (
                                <>
                                  <BiVideoPlus className="w-5 h-5" />
                                  Join call
                                </>
                              ) : (
                                <>
                                  <MdCall className="w-5 h-5" />
                                  Audio
                                </>
                              )}
                            </>
                          ) : (
                            <>
                              <IoPersonSharp className="w-5 h-5" /> Consult
                            </>
                          )}
                        </button>
                      </Tooltip>
                    ) : (
                      <button
                        onClick={() => handleClick(record, "1")}
                        className="bg-brand-primaryColor text-white  px-3 py-2 rounded flex items-center gap-1 w-28"
                      >
                        {record.serviceCode === "APPT_VIDEO" || record.serviceCode === "APPT_AUDIO" ? (
                          <>
                            {record.serviceCode === "APPT_VIDEO" ? (
                              <>
                                <BiVideoPlus className="w-5 h-5" />
                                Join call
                              </>
                            ) : (
                              <>
                                <MdCall className="w-5 h-5" />
                                Audio
                              </>
                            )}
                          </>
                        ) : (
                          <>
                            <IoPersonSharp className="w-5 h-5" /> Consult
                          </>
                        )}
                      </button>
                    )}
                  </td>

                  <td>
                    {record.status === 2 ? (
                      <div className="p-3 flex gap-2">
                        <div
                          onClick={() => handleClick(record, "2")}
                          className="w-8 h-8 rounded-full bg-[#DEF3F2] flex items-center justify-center cursor-pointer"
                        >
                          <img src={Edit} alt="" />
                        </div>
                        <div className="w-8 h-8 rounded-full bg-[#DEF3F2] flex items-center justify-center cursor-pointer">
                          <img
                            src={View}
                            alt=""
                            onClick={() => handlePrescriptionPreview(record)}
                          />
                        </div>
                        <SharePrescription record={record} />
                      </div>
                    ) : (
                      <div className="p-3 flex gap-2">
                        <div className="w-8 h-8 rounded-full bg-gray-300 flex items-center justify-center cursor-not-allowed">
                          <img src={EditWhite} alt="" />
                        </div>
                        <div className="w-8 h-8 rounded-full bg-gray-300 flex items-center justify-center cursor-not-allowed">
                          <img src={ViewWhite} alt="" />
                        </div>
                        <div className="w-8 h-8 rounded-full bg-gray-300 flex items-center justify-center cursor-not-allowed">
                          <img src={ShareWhite} alt="" />
                        </div>
                      </div>
                    )}
                  </td>

                  <td className="p-3 whitespace-nowrap flex flex-col gap-1">
                    <span
                      className={`p-2 rounded-md text-center text-sm  ${record.transactionId
                        ? "bg-[#31E4A81A] text-green-600"
                        : "bg-[#FF60601A] text-red-600"
                        }`}
                    >
                      {record.transactionId ? (
                        <span className="">Completed</span>
                      ) : (
                        <span className="">Pending</span>
                      )}
                    </span>
                    <PayAgain record={record} />
                  </td>
                  <td className="">
                    {record.status === 2 ? (
                      <div className="p-3 flex gap-2">
                        <ShareOrders
                          record={record}
                          getList={upcomingAppointmentList}
                        />
                      </div>
                    ) : (
                      <div className="p-3 flex gap-2">
                        <span className="w-8 h-8 rounded-full bg-gray-300 flex items-center justify-center cursor-not-allowed">
                          <img src={MedWhite} alt="" />
                        </span>
                        <span className="w-8 h-8 rounded-full bg-gray-300 flex items-center justify-center cursor-not-allowed">
                          <img src={LabWhite} alt="" />
                        </span>
                      </div>
                    )}
                  </td>
                  <td className="p-3 whitespace-nowrap">
                    {record.drugPrescriptionStatus === "Dispensed"  ? (
                      <div className="flex justify-center items-center">
                        <span
                          className=" border p-1 rounded-md border-brand-primaryColor cursor-pointer"
                          onClick={() => handlePharmaMedOpen(record, "M")}
                        >
                          {record.pharmacyOrderId}
                        </span>
                      </div>
                    ) : (
                      <span className="bg-[#31E4A81A] text-green-600 px-4 py-2 rounded-md text-sm w-[104px] h-[28px] ">
                        {record.drugPrescriptionStatus
                          ? record.drugPrescriptionStatus
                          : "N/A"}
                      </span>
                    )}
                  </td>
                  <td className="p-3 whitespace-nowrap">
                    {record.labPrescriptionStatus == "Tested" ? (
                      <div className="flex justify-center gap-1 items-center">
                        <span
                          className=" border p-1 rounded-md border-brand-primaryColor cursor-pointer"
                          onClick={() => handlePharmaMedOpen(record, "L")}
                        >
                          {record.labOrderId}
                        </span>
                        <img
                          src={Preview}
                          alt="Preview"
                          className="w-6 h-6 rounded-md cursor-pointer"
                          onClick={() => {
                            setShowLabReport(true);
                            setLabReportData(record);
                          }}
                        />
                      </div>
                    ) : (
                      <span className="bg-[#31E4A81A] text-green-600 px-4 py-2 rounded-md text-sm w-[104px] h-[28px] ">
                        {record.labPrescriptionStatus
                          ? record.labPrescriptionStatus
                          : "N/A"}
                      </span>
                    )}
                  </td>
                  <td className="p-3">
                    {record.status === 9 && (
                      <span
                        className="px-4 py-2 rounded-md text-sm bg-[#FF60601A] text-red-600 "
                        disabled
                      >
                        Cancelled
                      </span>
                    )}
                    {record.status === 0 && (
                      <span className="px-4 py-2 rounded-md text-sm bg-[#EBA8171A] text-yellow-600">
                        Pending
                      </span>
                    )}
                    {record.status === 1 && (
                      <span className="px-4 py-2 rounded-md text-sm bg-[#EBA8171A] text-yellow-600">
                        Pending
                      </span>
                    )}
                    <div className="flex gap-3">
                      {record.status === 2 && (
                        <span className="px-4 py-2 rounded-md text-sm bg-[#31E4A81A] text-green-600 ">
                          Completed
                        </span>
                      )}
                      {record.status === 2 &&
                        record.serviceCode === "APPT_INPERSON" && (
                          <Summary record={record} />
                        )}
                    </div>
                  </td>
                  <td>
                    {record.status === 1 ? (
                      <div className="p-3 flex gap-2">
                        <Tooltip placement="right" title={"Cancel Appointment"}>
                          <div
                            onClick={() => showModal(record)}
                            className="w-8 h-8 rounded-full bg-[#DEF3F2] flex items-center justify-center cursor-pointer"
                          >
                            <img src={close} alt="" />
                          </div>
                        </Tooltip>
                        <Tooltip placement="top" title={"Share Link"}>
                          <div className="w-8 h-8 rounded-full bg-[#DEF3F2] flex items-center justify-center cursor-pointer">
                            <RWebShare
                              data={{
                                text: "Appointment",
                                url:
                                  `${process.env.REACT_APP_WEBSITEURL}vc?ref=` +
                                  record?.appointmentId +
                                  "/N",
                                title: "Share Link",
                              }}
                            >
                              <img src={Share} alt="" />
                            </RWebShare>
                          </div>
                        </Tooltip>
                        <RescheduleAppt
                          record={record}
                          getList={upcomingAppointmentList}
                        />
                      </div>
                    ) : (
                      <div className="p-3 flex gap-2">
                        <div className="w-8 h-8 rounded-full text-white bg-gray-300 flex items-center justify-center cursor-not-allowed">
                          <IoMdClose />
                        </div>
                        <div className="w-8 h-8 rounded-full bg-gray-300 flex items-center justify-center cursor-not-allowed">
                          <img src={ShareWhite} alt="" />
                        </div>
                        <div className="w-8 h-8 rounded-full text-white bg-gray-300 flex items-center justify-center cursor-not-allowed">
                          <FaCalendarAlt className="text-white" />
                        </div>
                      </div>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <NoAppointmentsCard />
        )}
      </div>

      <Modal
        title="Cancel Appointment"
        open={isModalOpen}
        onCancel={cancelAppointment}
        footer={[]}
        width={400}
        destroyOnClose
      >
        <div>
          <span className="font-sans font-normal text-s">
            Are you sure you want to cancel this appointment?
          </span>
          <div className="relative mt-5">
            <textarea
              onChange={(e) => {
                setCancelReason(e.target.value);
              }}
              rows="4"
              className="peer w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:border-brand-primaryColor text-sm font-medium text-[#333] bg-transparent"
            />
            <label
              className="absolute left-2 -top-2 text-xs text-gray-500 transition-all peer-placeholder-shown:top-3 peer-placeholder-shown:text-xs peer-placeholder-shown:text-[#959595] peer-focus:-top-2 peer-focus:text-brand-primaryColor  peer-focus:text-[10px] bg-white px-1"
              htmlFor="cancelReason"
            >
              Cancel Reason...
            </label>
            <Checkbox
              checked={refundable}
              disabled={
                cancelAppointmentID?.status === 0 ||
                cancelAppointmentID?.status === 9 ||
                (cancelAppointmentID?.paymentType === "FullDiscount" &&
                  cancelAppointmentID?.status === 1)
                //   ||
                // cancelAppointmentID?.paymentType === "Cash"
              }
              onChange={handleRefundable}
              className="text-[#969CA5] gap-2"
            />
            <label className="text-[#A0A2A3] ">Refund Applicable</label>
          </div>
          <div className="flex justify-end border-brand-colorBorder gap-3 mt-10">
            <Button
              className="h-8 Btnwhite  w-20 text-[#189FAA]"
              onClick={cancelAppointment}
            >
              Cancel
            </Button>
            <Button
              onClick={handleOk}
              className="h-8 w-40 font-sans font-semibold bg-brand-primaryColor"
              type="primary"
            >
              Ok
            </Button>
          </div>
        </div>
      </Modal>
      <Modal
        title="Prescription"
        open={preview}
        onOk={download}
        onCancel={cancel}
        style={{
          top: 40,
        }}
        width={1000}
        footer={null}
      >
        <PrescriptionDetails
          prescription={selectedPrescription}
          selectedPatient={selectedPatient}
        />
      </Modal>
      {showLabReport && (
        <Modal
          title="Lab Reports"
          open={showLabReport}
          onCancel={() => {
            setShowLabReport(false);
          }}
          style={{
            top: 40,
          }}
          width={800}
          footer={null}
        >
          <ViewLabReports labReportData={labReportData} />
        </Modal>
      )}

      {pharmaMed && (
        <Modal
          title=""
          open={pharmaMed}
          onCancel={handlePharmaMedClose}
          style={{
            top: 40,
          }}
          width={1000}
          footer={null}
        >
          {previewType === "M" ? (
            <MedOrderPreview medRecord={medRecord} />
          ) : (
            <LabOrderPreview medRecord={medRecord} />
          )}
        </Modal>
      )}
    </div>
  );
}

export default UpcomeAppointment;
